import { useState, useCallback } from 'react';
import { generateProgressNote } from '@/utils/printExport';

/** Progress note panel: generate, edit, copy (PSD §8.2 / TODO Task 2.20). */
export function ProgressNote(): JSX.Element {
  const [note, setNote] = useState('');
  const [copied, setCopied] = useState(false);

  const generate = useCallback(() => {
    setNote(generateProgressNote());
    setCopied(false);
  }, []);

  const copy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(note);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  }, [note]);

  return (
    <section className="panel panel-result" aria-label="Progress note" data-testid="progress-note">
      <h2 className="panel-title">Progress Note</h2>
      <div className="actions-row">
        <button className="btn btn-sm" onClick={generate} data-testid="generate-note">
          Generate Note
        </button>
        {note && (
          <button className="btn btn-sm" onClick={copy} data-testid="copy-note">
            {copied ? 'Copied!' : 'Copy'}
          </button>
        )}
      </div>
      {note && (
        <textarea
          className="modal-textarea mt-2 textarea-mono"
          rows={20}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          data-testid="note-textarea"
        />
      )}
    </section>
  );
}
